<template>
  <artisio-modal
          :visible="visible"
          :title="$t('Details')"
          :scrollable="true"
          hide-footer
          body-class=""
          size="lg"
          @show="onShow"
          @hidden="onHidden"
          :content-in-form="false">
    <spinner :with-text="true" :show="loading" spinner-size="3"/>
    <template v-if="activity && !loading">
      <template v-if="shouldOverrideBody()">
        <div v-for="(_, name) in $scopedSlots">
          <div v-if="name === `modal-body(${activity.action})`">
            <slot :name="name" v-bind:activity="activity"/>
          </div>
        </div>
      </template>
      <template v-else>
        <table class="info-table table table-sm">
          <tr>
            <th class="border-top-0">{{$t('Attribute')}}</th>
            <th class="border-top-0">{{$t('Old')}}</th>
            <th class="border-top-0">{{$t('New')}}</th>
          </tr>
<!--          <tr v-if="!excludeRow(field)" v-for="field in iterationArray()" :key="`row-create-${field}`">-->
<!--            <td>{{attributeLabel(field)}}</td>-->
<!--            <td v-html="isUpdate() ? localVisualizer(activity, field, activity.old_data[field]) : ''"></td>-->
<!--            <td v-html="localVisualizer(activity, field, activity.data[field])"></td>-->
<!--          </tr>-->
          <tr v-for="obj in displayData" :key="`row-create-${obj.field}`">
            <td>{{obj.label}}</td>
            <td v-html="obj.old"></td>
            <td v-html="obj.new"></td>
          </tr>
        </table>
      </template>
    </template>
  </artisio-modal>
</template>

<script>
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import Spinner from "@/core/components/common/Spinner";
  import {Formatter} from "@/core/services/formatter.service";
  import {
    excludeActivityFromUpdate,
    swapActivityOldNewFields
  } from "@/modules/sales/view/activities/overrideDefaultActivitiesFields";

  export default {
    name: "ActivityDetailsModal",
    components: {ArtisioModal, Spinner},
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      activity: {
        type: Object
      },
      valueVisualizer: {
        type: Function,
        required: true
      },
      attributesToSkip: {
        type: Array,
        default: () => []
      },
      actions: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        generalExcludeAttributes: [
          'pk',
          'table_name',
          'object_uuid',
          'created_by',
          'created_at',
          'updated_by',
          'updated_at'
        ],
        displayData: [],
        loading: false
      }
    },
    methods: {
      attributeLabel(attribute) {
        if (this.actions[this.activity.action] && this.actions[this.activity.action].attributeLabels) {
          return this.actions[this.activity.action].attributeLabels[attribute] || attribute;
        }
        return attribute;
      },
      isUpdate() {
        return this.activity.action.includes('update') && !excludeActivityFromUpdate.includes(this.activity.action);
      },
      oldDataExists() {
        return this.activity.action.includes('update')
      },
      async localVisualizer(activity, attr, val) {

        if (attr === 'created_at' || attr === 'updated_at') {
          return this.$options.filters.toDateTime(val);
        }

        if (val === '') {
          val = 'N/A';
        }

        // Boolean Fields
        if (val === true) {
          return this.$i18n.t('Yes');
        } else if (val === false) {
          return this.$i18n.t('No');
        }
        this.loading = true;
        let response = await this.valueVisualizer(activity, attr, val);
        this.loading = false;
        return response;
      },
      shouldOverrideBody() {
        for (let scopedSlotName in this.$scopedSlots) {
          if (scopedSlotName === `modal-body(${this.activity.action})`) {
            return true;
          }
        }

        return false;
      },
      excludeRow(attribute) {
        // Skips if action is creation and data is empty
        if (!this.isUpdate() && !this.activity.data[attribute]) {
          return true;
        }
        // Skips if attribute is in general excluded attributes array
        if (this.generalExcludeAttributes.includes(attribute)) {
          return true;
        }
        // Skip if fields were provided specifically for action
        if (this.actions[this.activity.action] && this.actions[this.activity.action].excludeAttributes) {
          return this.actions[this.activity.action].excludeAttributes.includes(attribute);
        }
        return false;
      },
      iterationArray() {
        if (this.actions[this.activity.action] && this.actions[this.activity.action].fields) {
          return this.actions[this.activity.action].fields;
        } else {
          if (this.isUpdate()) {
            return this.activity.changed_fields;
          } else {
            return Object.keys(this.activity.data);
          }
        }
      },
      async onShow() {
        for (let field of this.iterationArray()) {
          if (this.excludeRow(field)) {
            continue;
          }
          let old_field = this.oldDataExists() ? await this.localVisualizer(this.activity, field, this.activity.old_data[field]) : 'N/A'
          let new_field = await this.localVisualizer(this.activity, field, this.activity.data[field])

          if (field === 'date') {
            if (old_field !== 'N/A') {
              old_field = Formatter.toDate(old_field)
            }
            new_field = Formatter.toDate(new_field)
          }

          if (swapActivityOldNewFields.includes(this.activity.action)) {
            [old_field, new_field] = [new_field, old_field];
          }
          this.displayData.push({
            field,
            label: this.attributeLabel(field),
            old: old_field,
            new: new_field
          });
        }
      },
      onHidden() {
        this.displayData = [];
        this.$emit('hidden')
      }
    }
  }
</script>

<style scoped>
</style>
